import { useState, useEffect } from 'react';
import { getUserSession as getSession } from "../../../Common/lib/Session";
import { Auth } from "../../../Common/lib/auth";

import VerificationSection from './accountTabSections/verificationSection';
import AccountInfoSection from './accountTabSections/accountInfoSection';
import PasswordSection from './accountTabSections/passwordSection';

export default function AccountTab() {
  const [userProfile, setUserProfile] = useState({
    username: "",
    email: "",
    fname: "",
    lname: "",
    institute: "",
    phone_number: "",
    research_field: "",
    research_geo: "",
    is_staff: false,
    contributor_access: false,
  });

  useEffect(() => {
    getUserSession();
  }, []);

  const getUserSession = async () => {
    const session = await getSession();

    setUserProfile({
      username: session.username,
      email: session.email,
      fname: session.fname,
      lname: session.lname,
      institute: session.institute,
      phone_number: session.phone_number,
      research_field: session.research_field,
      research_geo: session.research_geo,
      is_staff: session.is_staff,
      contributor_access: session.contributor_access,
    });
  };

  return (
    <>
      <div className="mx-auto max-w-2xl space-y-8 sm:space-y-12 lg:mx-0 lg:max-w-none">
        <AccountInfoSection userProfile={userProfile} getUserSession={getUserSession} setUserProfile={setUserProfile}/>

        <VerificationSection userProfile={userProfile}/>

        <PasswordSection userProfile={userProfile}/>
      </div>
    </>
  );
}